import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import {
  CheckTextSelect,
  DemanderKbn,
  DemanderRelationship,
  DispDepositType,
  DomesticResidenceFlg,
  IncomeKbn,
  RetireKbn,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

// 退職者本人
const retireeStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 相続人
const heirStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 遺族
const bereavedStepper = [
  "退職者確認",
  "添付書類の登録",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    explanatoryText: "■退職手当金請求書",
    keyword: "explanatoryText",
    type: "explanatoryText",
  },
  {
    title: "勤務先",
    keyword: "facilityName",
    type: "text",
  },
  {
    title: "退職者氏名",
    keyword: "retirementStaffName",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "被共済職員期間",
    keyword: "maePeriod",
    type: "text",
  },
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "退職理由",
    keyword: "retirementReason",
    disabled: true,
    showLine: true,
  },
  {
    title: "請求者区分",
    keyword: "demanderKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(DemanderKbn),
    disabled: true,
  },
  {
    title: "続柄",
    keyword: "demanderRelationship",
    type: "radio",
    radioPropsList: TkGetCodeList(DemanderRelationship),
    showLine: false,
    disabled: true,
  },
  {
    title: "「その他」入力欄",
    keyword: "demanderRelationshipOthers",
    type: "text",
    showLine: false,
  },
  {
    title: "退職者からの生計維持の有無",
    keyword: "livelihoodFromRetireeFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    showLine: false,
    disabled: true,
  },
  {
    title: "あなたと同順位の請求権保持者の有無",
    keyword: "demanderFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    showLine: false,
    disabled: true,
  },
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    type: "name",
    disabled: true,
  },
  {
    title: "請求者氏名（全角漢字）",
    keyword: "demanderName",
    type: "name",
    disabled: true,
  },
  {
    title: "請求者生年月日",
    keyword: "demanderBirth",
    type: "date",
    disabled: true,
  },
  {
    title: "請求者現住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "postcode",
    disabled: true,
  },
  {
    title: "請求者現住所",
    keyword: "demanderAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: "請求者メールアドレス（機構連絡用）",
    keyword: "demanderEmail",
    type: "mail",
    disabled: true,
  },
  {
    title: "代行者連絡先メールアドレス",
    keyword: "agentEmail",
    type: "mail",
    disabled: true,
    showLine: false,
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
  },
  {
    title: "金融機関名",
    keyword: "bankName",
    type: "text",
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "radio",
    radioPropsList: TkGetCodeList(DispDepositType),
    disabled: true,
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    disabled: true,
  },
  {
    title: "口座名義人名（半角ｶﾀｶﾅ）",
    keyword: "accountNameKana",
    type: "name",
    disabled: true,
  },
  {
    title: "海外送金",
    keyword: "sendMoneyAbroad",
    type: "checkboxGroup",
    checkBoxList: [{ label: "海外送金", disabled: true }],
    showLine: false,
  },
  {
    title: "国内居住",
    keyword: "domesticResidenceFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(DomesticResidenceFlg),
    disabled: true,
    showLine: false,
  },
  {
    title: "「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathOrAutopsyReport",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "marriageReport",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "職員の死亡を証する「戸籍謄本」又は「除籍謄本」",
    keyword: "certifiedCertificateResidence",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "その他、事実上の配偶者であることを証明する書類",
    keyword: "claimantPartnerBook",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "確認する書類の選択",
    keyword: "identificationDocsKind",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CheckTextSelect),
    disabled: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs1",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identityDocs2",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類（表面）",
    keyword: "identityDocHead",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "本人であることを確認するための書類（裏面）",
    keyword: "identityDocTail",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "死亡した退職者の個人番号を確認する書類",
    keyword: "deceasedRetireeNumCheckDoc",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "旧姓と新姓が確認できる住民票",
    keyword: "nameConfirmation",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "個人番号を確認する書類",
    keyword: "numberCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "振込先口座が確認できる書類",
    keyword: "payAccountCheckDoc",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "委任状",
    keyword: "commission",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    explanatoryText: "■退職所得の受給に関する申告書兼退職所得申告書",
    keyword: "explanatoryText",
    type: "explanatoryText",
  },
  {
    title: "法人が添付した源泉徴収票（1枚目）",
    keyword: "attachedTax1",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "法人が添付した源泉徴収票（2枚目）",
    keyword: "attachedTax2",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "法人が添付した源泉徴収票（3枚目）",
    keyword: "attachedTax3",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "（1枚目）退職所得の源泉徴収票",
    keyword: "page1RetireeTax",
    type: "downloadLink",
    downloadBase64: true,
  },
  {
    title: "（1枚目）就労年月日",
    keyword: "page1EmployedDate",
    type: "date",
    disabled: true,
  },
  {
    title: "（1枚目）退職年月日",
    keyword: "page1RetiredDate",
    type: "date",
    disabled: true,
  },
  {
    title: "（1枚目）区分",
    keyword: "page1Kbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    disabled: true,
  },
  {
    title: "（1枚目）支払金額",
    keyword: "page1PaymentAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "（1枚目）源泉徴収票",
    keyword: "page1WithholdingAmt",
    type: "amount",
    disabled: true,
  },
  {
    title: "（1枚目）特別徴収税額:市町村民税",
    keyword: "page1ScAmtCity",
    type: "amount",
    disabled: true,
  },
  {
    title: "（1枚目）特別徴収税額:都道府県税",
    keyword: "page1ScAmtPrefecture",
    type: "amount",
    disabled: true,
  },
  {
    title: "（1枚目）勤続年数",
    keyword: "page1LengthOfService",
    type: "amount",
    innerText: "年",
    disabled: true,
  },
  {
    title: "（1枚目）控除期間（年）",
    keyword: "page1DeductionPeriodYear",
    type: "amount",
    innerText: "年",
    disabled: true,
  },
  {
    title: "（1枚目）控除期間（月）",
    keyword: "page1DeductionPeriodMonth",
    type: "amount",
    innerText: "月",
    disabled: true,
  },
  {
    title: "（2枚目）退職所得の源泉徴収票",
    keyword: "page2RetireeTax",
    type: "downloadLink",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "（2枚目）就労年月日",
    keyword: "page2EmployedDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）退職年月日",
    keyword: "page2RetiredDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）区分",
    keyword: "page2Kbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）支払金額",
    keyword: "page2PaymentAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）源泉徴収額",
    keyword: "page2Tax",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）特別徴収税額:市町村民税",
    keyword: "page2ScAmtCity",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）特別徴収税額:都道府県税",
    keyword: "page2ScAmtPrefecture",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）勤続年数",
    keyword: "page2LengthOfService",
    type: "amount",
    innerText: "年",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）控除期間（年）",
    keyword: "page2DeductionPeriodYear",
    type: "amount",
    innerText: "年",
    disabled: true,
    showLine: false,
  },
  {
    title: "（2枚目）控除期間（月）",
    keyword: "page2DeductionPeriodMonth",
    type: "amount",
    innerText: "月",
    disabled: true,
    showLine: false,
  },
  {
    title: "氏名",
    keyword: "name",
    type: "name",
    disabled: true,
  },
  {
    title: "現住所",
    keyword: "nowAddress",
    type: "locationGroup",
    disabled: true,
    showLine: false,
  },
  {
    title: "個人番号",
    keyword: "number",
    type: "text",
    text: "別添の個人番号確認書類のとおり",
  },
  {
    title: "その年１月１日現在の住所",
    keyword: "yearOneToOnelocation",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    disabled: true,
  },
  {
    title: "【A】①　退職手当等の支払を受けることとなった年月日",
    keyword: "paymentConfirmDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "【A】②　退職区分等",
    keyword: "retireKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    disabled: true,
    showLine: false,
  },
  {
    title: "【A】生活扶助の有無",
    keyword: "livingAssistanceFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
    showLine: false,
  },
  {
    title: "【A】③　この申告書の提出先から受ける退職手当等についての勤続期間", //退職手当等についての勤続期間（自）と退職手当等についての勤続期間（至）を設定する。
    keyword: "joinAndRetireDate",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title: "【B】他の退職金の支払いの有無",
    keyword: "areaBInputCheck",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
    showLine: true,
  },
  {
    title: "【B】④本年中に支払を受けた他の退職手当等についての勤続期間", //本年中に支払を受けた他の退職手当等についての勤続期間（自）と本年中に支払を受けた他の退職手当等についての勤続期間（自）を設定する。
    keyword: "ltotalCurrentYearLosFromPageB",
    type: "durationPicker",
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title: "【B】⑤　③と④の通算勤続期間",
    keyword: "LengthOfCommutingServicePageB",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title: "【C】他の退職金の支払いの有無",
    keyword: "areaCInputCheck",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
    showLine: true,
  },
  {
    title:
      "【C】⑥　前年以前４年内に支払を受けた他の退職手当等についての勤続期間",
    keyword: "past4yearsLosFrom",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title: "【C】⑦　③又は⑤の勤続期間のうち、⑥の勤続期間と重複している期間",
    keyword: "todoone",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title: "【D】通算の有無",
    keyword: "areaDInputCheck",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
    showLine: false,
  },
  {
    title:
      "【D】⑧　Ａの退職手当等についての勤続期間（③）に通算された前の退職手当等についての勤続期間",
    keyword: "totalYearLosFrom",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title:
      "【D】⑨　Ｂの退職手当等についての勤続期間（④）に通算された前の退職手当等についての勤続期間",
    keyword: "totalCurrentYearLos",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title:
      "【D】⑩　③又は⑤の勤続期間のうち、⑧又は⑨の勤続期間だけからなる部分の期間",
    keyword: "ServicePeriodPortionStartPageD",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    round: "floorAdd",
  },
  {
    title: "【D】⑪ ⑦と⑩の通算期間",
    keyword: "sevenAndThreeCommencementOfPeriodStartPageD",
    type: "durationPicker",
    disabled: true,
    showLine: false,
    showYears: true,
    round: "floorAdd",
  },
  {
    title: "【E】B欄又はC欄の退職手当等の有無",
    keyword: "RetirementAllowancePageE",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　退職手当等の支払を受けることとなった年月日",
    keyword: "currentYearPaymentDecisionDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　収入金額",
    keyword: "currentYearRetirementAllowanceAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　源泉徴収額",
    keyword: "currentYearWithholdingAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　特別徴収税額（市町村民税）",
    keyword: "currentYearScCityAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　特別徴収税額（都道府県民税）",
    keyword: "currentYearScPrefectureAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　支払いを受けた年月日",
    keyword: "currentYearGetPaidDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　退職の区分",
    keyword: "currentYearRetirementKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　支払者の所在地（住所）（都道府県）",
    keyword: "currentYearPayerAddress",
    type: "locationGroup",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分B　支払者の名称（氏名）（全角）",
    keyword: "currentYearPayerName",
    type: "name",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　退職手当等の支払を受けることとなった年月日",
    keyword: "past4yearsPaymentDecisionDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　収入金額",
    keyword: "past4yearsRetirementAllowanceAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　源泉徴収額",
    keyword: "past4yearsWithholdingAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　特別徴収税額（市町村民税）",
    keyword: "past4yearsScCityAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　特別徴収税額（都道府県民税）",
    keyword: "past4yearsScPrefectureAmt",
    type: "amount",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　支払いを受けた年月日",
    keyword: "past4yearsGetPaidDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　退職の区分",
    keyword: "past4yearsRetirementKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　支払者の所在地（住所）",
    keyword: "past4yearsPayerAddress",
    type: "locationGroup",
    disabled: true,
    showLine: false,
  },
  {
    title: "【E】区分C　支払者の名称（氏名）（全角）",
    keyword: "past4yearsPayerName",
    type: "name",
    disabled: true,
    showLine: false,
  },
];

const schema: any = {};

export { retireeStepper, heirStepper, bereavedStepper, fakeTableList, schema };
